<template>
    <section class="py-3.5">
        <div class="flex items-center px-2">
            <h2 class="text-sm font-medium">{{ __('Users') }}</h2>
            <div class="relative ml-auto" modal="true" name="task-assign">
                <div>
          <span class="cursor-pointer" @click="toggleAssigneeBox">
            <icon class="h-5 w-5 hover:opacity-80" name="add"/>
          </span>
                </div>

                <!-- Assignee Selection Box -->
                <div
                    class="absolute right-1 flex w-[300px] z-10 text-sm flex-col bg-white px-4 py-4 rounded shadow"
                    v-if="showAssigneeBox"
                >
                    <h4 class="text-center mb-3 font-bold">{{ __('Users') }}</h4>
                    <div
                        class="absolute cursor-pointer hover:bg-gray-200 top-3 right-3 p-1.5 rounded"
                        @click="toggleAssigneeBox"
                    >
                        <icon class="w-4 h-4" name="close"/>
                    </div>
                    <input
                        id="t_d_s_u"
                        v-model="user_search"
                        class="border-[2px] px-2 py-1 border-gray-400 rounded-[3px]"
                        :placeholder="__('Search User')"
                    />

                    <!-- Select All Option -->
                    <label class="flex p-2 cursor-pointer hover:bg-gray-200 rounded">
                        <input
                            class="w-5 ml-1 mr-2"
                            type="checkbox"
                            :checked="isAllSelected"
                            @change="toggleSelectAll"
                        />
                        <span>{{ __('Select All') }}</span>
                    </label>

                    <ul class="flex flex-col mt-3 gap-1 h-48 max-h-48 overflow-y-auto">
                        <li v-for="(userObject, user_index) in filteredUsers" :key="user_index">
                            <label :for="'td_u_id_' + user_index"
                                   class="flex p-2 cursor-pointer hover:bg-gray-200 rounded"
                            >
                                <input
                                    :id="'td_u_id_' + user_index"
                                    class="w-5 ml-1 mr-2"
                                    type="checkbox"
                                    :checked="selectedTaskUsers().includes(userObject.id)"
                                    @change="assignUserToTask($event.target.checked, userObject.id)"
                                />
                                <img
                                    v-if="userObject.photo_path"
                                    :aria-label="userObject.name"
                                    :alt="userObject.name"
                                    class="w-6 h-6 rounded-full"
                                    :src="userObject.photo_path"
                                />
                                <img
                                    :aria-label="userObject.name"
                                    :alt="userObject.name"
                                    class="w-6 h-6 rounded-full"
                                    src="/images/user.svg"
                                />
                                <span class="p-1">{{ userObject.name }}</span>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
    components: {
        Icon,
    },
    props: {
        users: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        value: {
            type: Array,
            default: () => [], // Initialize with an empty array if no value is passed
        },
    },
    data() {
        return {
            showAssigneeBox: false,
            user_search: '',
            task_assignees: [...this.value],
            temp: [], // Array to hold selected assignees
        }
    },
    watch: {
        // Sync changes to `value` (v-model)
        value(newValue) {
            this.task_assignees = [...newValue];
        },
        task_assignees(newValue) {
            this.$emit('input', newValue);
        },
    },
    methods: {
        toggleAssigneeBox() {
            this.showAssigneeBox = !this.showAssigneeBox;
        },
        isUserAssigned(user_id) {
            return this.task_assignees.some(assignee => assignee.id === user_id);
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.task_assignees = []; // Deselect all users
            } else {
                this.task_assignees = [...this.users]; // Select all users
            }
            this.emitSelectedUsers();
        },
        selectedTaskUsers() {
            return this.task_assignees.map(item => item.id); // Return selected user IDs
        },
        assignUserToTask(isChecked, user_id) {
            const userObject = this.users.find(user => user.id === user_id);
            if (isChecked && userObject) {
                // Add user to the selected list if not already present
                if (!this.isUserAssigned(user_id)) {
                    this.task_assignees.push(userObject);
                }
            } else {
                // Remove user from the selected list
                this.task_assignees = this.task_assignees.filter(user => user.id !== user_id);
            }
            this.emitSelectedUsers();
        },
        emitSelectedUsers() {
            // Emit the updated list of selected users to the parent
            this.$emit('update:selectedUsers', this.task_assignees);
        },
    },
    computed: {
        filteredUsers() {
            return this.user_search
                ? this.users.filter(userObject => userObject.name.toLowerCase().includes(this.user_search.toLowerCase()))
                : this.users;
        },
        isAllSelected() {
            return this.task_assignees.length === this.users.length && this.users.every(user => this.isUserAssigned(user.id));
        },
    },
}
</script>
